export default "__VITE_ASSET__D5VqA6$k__"